module.exports = __webpack_public_path__ + "static/media/menu.0e8ee8b4.svg";